// Module
var code = "If you clicked by mistake, <a class=\"underline\" data-cy=\"cancel-unsubscribe\" href=\"{reaboUrl}\" target=\"_blank\">click here</a> to continue receiving our emails.";
// Exports
module.exports = code;